import React from 'react';
import { Button } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

export default class Generate extends React.Component {

    state = { confirmation: false, barcodeValue: null };

    generateBarcodeValue = (productId) => {
        return productId;
    }

    generateBarcode = async () => {
        let productId = this.props.productId;
        const barcodeValue = await this.generateBarcodeValue(productId);
        this.props.updateState('barcode', barcodeValue);
        this.setState({
            barcodeValue: barcodeValue,
            confirmation: false
        });
        this.props.updateValue();
        if (this.props.onBarcodeGenerated) {
            this.props.onBarcodeGenerated(barcodeValue);
        }
    }

    render() {
        return (
            <div>
                <Button type='submit' onClick={() => this.setState({ confirmation: true })} positive>Generate</Button>
                <Dialog
                    fullWidth={true}
                    maxWidth={'sm'}
                    open={this.state.confirmation}
                    onClose={() => { this.setState({ confirmation: false }) }}
                    aria-labelledby="max-width-dialog-title"
                >
                    <DialogTitle id="max-width-dialog-title">
                        Confirmation
                    </DialogTitle>
                    <DialogContent>
                        Are you sure to generate a new barcode for this product?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.generateBarcode} positive autoFocus>
                            Yes
                        </Button>
                        <Button onClick={() => { this.setState({ confirmation: false }) }} negative>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
